var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.formOption.busy } },
    [
      _c(
        "a-form",
        {
          ref: "form",
          attrs: {
            form: _vm.form,
            "label-col": { span: 12 },
            "wrapper-col": { span: 12 },
          },
        },
        [
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "问题名称",
                        "label-col": { span: 4 },
                        "wrapper-col": { span: 20 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["questionName", _vm.rules.questionName],
                            expression: "['questionName',rules.questionName]",
                          },
                        ],
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "问题分组" } },
                    [
                      _c("a-tree-select", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["questionTypeId", _vm.rules.questionTypeId],
                            expression:
                              "['questionTypeId',rules.questionTypeId]",
                          },
                        ],
                        attrs: {
                          "allow-clear": "",
                          "dropdown-style": {
                            maxHeight: "300px",
                            overflow: "auto",
                          },
                          treeData: _vm.treeData,
                          replaceFields: {
                            children: "children",
                            title: "questionTypeName",
                            key: "questionTypeId",
                            value: "questionTypeId",
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "关键词",
                        "label-col": { span: 6 },
                        "wrapper-col": { span: 16 },
                      },
                    },
                    [
                      _c("a-select", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["keyWords"],
                            expression: "['keyWords']",
                          },
                        ],
                        attrs: { mode: "multiple", options: _vm.tagOptions },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-button",
                    { attrs: { type: "link" }, on: { click: _vm.addTag } },
                    [_vm._v("新增")]
                  ),
                  _c(
                    "a-button",
                    { attrs: { type: "link" }, on: { click: _vm.refreshTag } },
                    [_vm._v("刷新")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._l(_vm.answerList, function (item, index) {
            return _c(
              "div",
              { key: index },
              [
                _c(
                  "a-row",
                  { attrs: { gutter: 24 } },
                  [
                    _c(
                      "a-col",
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              color: "#ff0000",
                              "line-height": "30px",
                              "padding-left": "11%",
                            },
                          },
                          [
                            _vm._v(
                              " 答案" +
                                _vm._s(index + 1) +
                                ":（仅可选择一类消息类型，若切换则已填写内容会被清空） "
                            ),
                            _c("a-icon", {
                              staticStyle: {
                                float: "right",
                                cursor: "pointer",
                                "font-size": "18px",
                              },
                              attrs: { type: "minus-circle" },
                              on: {
                                click: function ($event) {
                                  return _vm.delAnswer(index)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "a-form-item",
                          {
                            attrs: {
                              label: "消息类型",
                              "label-col": { span: 4 },
                              "wrapper-col": { span: 20 },
                            },
                          },
                          [
                            _c(
                              "a-radio-group",
                              {
                                attrs: { "button-style": "solid" },
                                model: {
                                  value: item.typeId,
                                  callback: function ($$v) {
                                    _vm.$set(item, "typeId", $$v)
                                  },
                                  expression: "item.typeId",
                                },
                              },
                              [
                                _c("a-radio-button", { attrs: { value: 1 } }, [
                                  _vm._v("文本"),
                                ]),
                                _c("a-radio-button", { attrs: { value: 2 } }, [
                                  _vm._v("图片"),
                                ]),
                                _c("a-radio-button", { attrs: { value: 3 } }, [
                                  _vm._v("文件"),
                                ]),
                                _c("a-radio-button", { attrs: { value: 4 } }, [
                                  _vm._v("链接"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-row",
                  { attrs: { gutter: 24 } },
                  [
                    item.typeId === 1
                      ? [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "答案内容",
                                "label-col": { span: 4 },
                                "wrapper-col": { span: 20 },
                              },
                            },
                            [
                              _c("a-textarea", {
                                model: {
                                  value: item.text,
                                  callback: function ($$v) {
                                    _vm.$set(item, "text", $$v)
                                  },
                                  expression: "item.text",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                    item.typeId === 2
                      ? [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "图片设置",
                                "label-col": { span: 4 },
                                "wrapper-col": { span: 20 },
                              },
                            },
                            [
                              _c("uploader", {
                                attrs: {
                                  num: 1,
                                  accept: ".jpg,.png",
                                  url: _vm.api.temp.UPLOAD_TALK,
                                },
                                model: {
                                  value: item.picUrl,
                                  callback: function ($$v) {
                                    _vm.$set(item, "picUrl", $$v)
                                  },
                                  expression: "item.picUrl",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#f00",
                                "margin-left": "16.66666666666666666%",
                              },
                            },
                            [_vm._v("建议格式：png,jpg，最大为10MB，最多9张")]
                          ),
                        ]
                      : _vm._e(),
                    item.typeId === 3
                      ? [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "文件设置",
                                "label-col": { span: 4 },
                                "wrapper-col": { span: 20 },
                              },
                            },
                            [
                              _c("uploader", {
                                attrs: {
                                  num: 1,
                                  accept: "*",
                                  url: _vm.api.temp.UPLOAD_TALK,
                                },
                                model: {
                                  value: item.fileUrl,
                                  callback: function ($$v) {
                                    _vm.$set(item, "fileUrl", $$v)
                                  },
                                  expression: "item.fileUrl",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#f00",
                                "margin-left": "16.66666666666666666%",
                              },
                            },
                            [_vm._v("最大为20MB，最多1个")]
                          ),
                        ]
                      : _vm._e(),
                    item.typeId === 4
                      ? [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "网页标题",
                                "label-col": { span: 4 },
                                "wrapper-col": { span: 20 },
                              },
                            },
                            [
                              _c("a-input", {
                                model: {
                                  value: item.linkName,
                                  callback: function ($$v) {
                                    _vm.$set(item, "linkName", $$v)
                                  },
                                  expression: "item.linkName",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "网页链接",
                                "label-col": { span: 4 },
                                "wrapper-col": { span: 20 },
                              },
                            },
                            [
                              _c("a-input", {
                                model: {
                                  value: item.linkUrl,
                                  callback: function ($$v) {
                                    _vm.$set(item, "linkUrl", $$v)
                                  },
                                  expression: "item.linkUrl",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                    item.typeId === 5 ? [_vm._v(" 待开发 ")] : _vm._e(),
                  ],
                  2
                ),
              ],
              1
            )
          }),
          _c(
            "div",
            {
              staticStyle: { "padding-left": "11%", color: "#ff0000" },
              on: { click: _vm.addAnswer },
            },
            [
              _c("a-icon", { attrs: { type: "plus-circle" } }),
              _vm._v(" 添加答案 "),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "a-space",
        { staticClass: "a-form-btn-box" },
        [
          _c(
            "a-button",
            {
              on: {
                click: function ($event) {
                  return _vm.endEdit("cancelled")
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "a-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm._save(false)
                },
              },
            },
            [_vm._v("保存")]
          ),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "新增关键词",
            closable: true,
            footer: null,
            maskClosable: false,
            visible: _vm.editModalVisible,
            width: 600,
          },
          on: { cancel: _vm.closeEdit },
        },
        [
          _vm.editModalVisible
            ? _c("detailForm", {
                ref: "detailForm",
                attrs: { rowId: 0 },
                on: {
                  cancelled: function ($event) {
                    return _vm.closeEdit()
                  },
                  saved: function ($event) {
                    return _vm.closeEdit(true)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }